import { Component, OnInit } from '@angular/core';
import { LandingService } from '../../shared/services/landing.service';
import { Router } from '@angular/router';
import { UserRequest, AccountService } from '../../shared/shared.module';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  isLogged = false;
  user = new UserRequest();

  constructor(
    private router: Router,
    private landingService: LandingService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.accountService.isAuthenticated().then(result => {
        this.isLogged = result;
    });
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  checkLogin(pathForRedirect: string) {
    if (!this.isLogged) {
      this.openLoginDialog();
    } else {
      this.scrollTop();
      this.router.navigateByUrl(pathForRedirect);
    }
  }

  openLoginDialog() {
    if (!this.user.Email || !this.user.HPassword) {
      this.landingService.changeUser(this.user);
      this.landingService.toggleLoginDialog(true);
      this.user = new UserRequest();
      return;
    }

    this.landingService.callLogin(this.user);
    this.user = new UserRequest();
  }

}



// WEBPACK FOOTER //
// ./src/app/landing/info/info.component.ts